import React from "react";
import { bool } from "prop-types";
import { connect, useDispatch } from "react-redux";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import { Col } from "react-bootstrap";
import Button from "pages/_components/Button";
import * as i18nUtils from "util/i18n";

import { push } from "connected-react-router";

import CustomText from "pages/_components/CustomText/CustomText";
import Image from "pages/_components/Image";

const StepCaptureSelfieSuccess = ({ isMobile }) => {
    const dispatch = useDispatch();

    const onContinue = () => {
        dispatch(push("/onboarding/stepPersonalData"));
    };

    return (
        <>
            {isMobile && <Head title="onboarding.noUser.title" hideNavbarInMobile />}
            <MainContainer>
                {!isMobile && <Head title="onboarding.noUser.title" />}

                <Col xs={12} md={8} mdOffset={2}>
                    <h1 className="text-center">
                        <CustomText text={i18nUtils.get("", "¡Identidad validada exitosamente!")} />
                    </h1>
                </Col>
                <div className="illustration text-center">
                    <Image src="figma/illustrations/onboarding5.svg" className="svg-image logo" />
                </div>
                {/* <Col xs={12} md={8} mdOffset={2}>
                        <div className="bienvenida-alta-persona">Ilustración</div>
                    </Col> */}
                <div className="box box-border-soft">
                    <CustomText
                        text={i18nUtils.get(
                            "",
                            "Ahora que sabemos que sos vos, vamos a pedirte algunos datos personales.",
                        )}
                    />
                </div>

                <div className="form-actions">
                    <Button
                        bsStyle="primary"
                        label="global.continue"
                        loading={false}
                        onClick={onContinue}
                        defaultLabelText="Continuar"
                    />
                </div>
            </MainContainer>
        </>
    );
};

StepCaptureSelfieSuccess.propTypes = {
    isMobile: bool.isRequired,
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(StepCaptureSelfieSuccess);
